/* eslint-disable indent */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Descriptions, Divider, Alert, message } from 'antd';
import { EmailForm, TicketForm } from '../Forms';

export const TicketActions = ({
  fn = {
    handler: () => ({}),
    handlerSelected: () => ({}),
    selected: {},
    oClient: {},
  },
  modal = {
    form: {},
    handler: () => ({}),
    loading: false,
    submit: () => ({}),
    visible: false,
  },
  modal2 = {
    form: {},
    handler: () => ({}),
    loading: false,
    submit: () => ({}),
    visible: false,
  },
}) => {
  const [invoicesData, setInvoicesData] = useState({});
  const [currentTotal, setCurrentTotal] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  React.useEffect(() => {
    let interval;
    if (modal.form && typeof modal.form.getFieldsValue === 'function') {
      interval = window.setInterval(() => {
        const values = modal.form.getFieldsValue(true);
        setInvoicesData(values);
        setCurrentTotal(values.total);
      }, 300);
    }
    return () => {
      if (interval) {
        window.clearInterval(interval);
      }
    };
  }, [modal.form, fn.selected]);

  const handleInvoiceChange = values => {
    setInvoicesData(values);
    setCurrentTotal(values.total);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await modal.submit(invoicesData);
      modal.handler(false);
    } catch (error) {
      message.error('Ocurrió un error al procesar las facturas');
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return modal2?.visible ? (
    <Modal
      cancelText="Cancelar"
      centered
      destroyOnClose
      onCancel={() => {
        fn.handlerSelected({});
        modal2.handler(false);
        modal2.form.resetFields();
      }}
      onOk={() => modal2.form.submit()}
      okText="Enviar"
      okButtonProps={{
        loading: modal2.loading,
      }}
      title={`Reenviar Factura ${fn.selected.serie}-${fn.selected.folio}`}
      visible={modal2.visible}
    >
      <EmailForm formRef={modal2.form} onSubmit={modal2.submit} />
    </Modal>
  ) : (
    <Modal
      cancelText="Cancelar"
      centered
      destroyOnClose
      onCancel={() => {
        fn.handlerSelected({});
        modal.handler(false);
        modal.form.resetFields();
      }}
      onOk={handleSubmit}
      okText="Timbrar"
      okButtonProps={{
        loading: isSubmitting,
        disabled: (() => {
          // Verificar campos requeridos
          const requiredFields = [
            'cliente',
            'email',
            'total',
            'payment_form',
            'payment_method',
          ];

          const hasMissingFields = requiredFields.some(
            field =>
              invoicesData[field] === undefined ||
              invoicesData[field] === null ||
              invoicesData[field] === ''
          );

          // Verificar el total mínimo
          const invoiceTotal = invoicesData.total || 0;
          const hasInvalidTotal = Math.abs(invoiceTotal) < 0.01;

          // Verificar diferencia de totales
          const totalDifferenceInvalid =
            Math.abs(currentTotal - fn.selected.total) > 0.01;

          return hasMissingFields || hasInvalidTotal || totalDifferenceInvalid;
        })(),
      }}
      title={`Crear Factura de Ticket ${fn.selected.serie}-${fn.selected.folio}`}
      visible={modal.visible}
    >
      <Descriptions title="Factura">
        <Descriptions.Item label="Subtotal">
          {(fn.selected.total_bruto * 1).toFixed(2)}
        </Descriptions.Item>
        <Descriptions.Item label="IVA">
          {(
            (fn.selected.total_neto * 1).toFixed(2) -
            (fn.selected.total_bruto * 1).toFixed(2)
          ).toFixed(2)}
        </Descriptions.Item>
        <Descriptions.Item label="Total">
          {(fn.selected.total_neto * 1).toFixed(2)}
        </Descriptions.Item>
      </Descriptions>

      <Divider />

      <TicketForm
        formRef={modal.form}
        onSubmit={{}}
        oOrder={fn.selected}
        onValuesChange={values => handleInvoiceChange(values)}
        oClient={fn.oClient}
      />
      <div style={{ marginBottom: 16 }}>
        <Alert
          type={
            currentTotal - fn.selected.total_neto > 0.01 ? 'error' : 'success'
          }
          message={
            currentTotal - fn.selected.total_neto > 0.01
              ? 'El total no puede superar el total inicial'
              : `El total restante de la factura es de $${(
                  fn.selected.total_neto - currentTotal
                ).toFixed(2)}`
          }
        />
      </div>
    </Modal>
  );
};

TicketActions.propTypes = {
  fn: PropTypes.any.isRequired,
  modal: PropTypes.shape({
    form: PropTypes.object,
    handler: PropTypes.func,
    loading: PropTypes.bool,
    submit: PropTypes.func,
    visible: PropTypes.bool,
    oClient: PropTypes.object,
  }),
  modal2: PropTypes.shape({
    form: PropTypes.object,
    handler: PropTypes.func,
    loading: PropTypes.bool,
    submit: PropTypes.func,
    visible: PropTypes.bool,
    oClient: PropTypes.object,
  }),
};
